var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-container",
    [
      _c(
        "el-header",
        { staticStyle: { "background-color": "#fff" } },
        [
          _c(
            "el-row",
            { attrs: { type: "flex", justify: "space-between" } },
            [
              _c("el-col", { attrs: { span: 6 } }, [
                _c("div", { staticClass: "jzq-logo" }, [
                  _vm._v("\n\t\t\t\t\t\t数字证书申请认证\n\t\t\t\t\t")
                ])
              ]),
              _c(
                "el-col",
                {
                  staticStyle: { "min-width": "300px", background: "#fff" },
                  attrs: { span: 4 }
                },
                [_c("div", { staticClass: "jzq-return" })]
              )
            ],
            1
          )
        ],
        1
      ),
      _c("el-main", [_c("nuxt")], 1)
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-43afaa74", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-43afaa74","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./layouts/digital.vue
// module id = 04Ux
// module chunks = 203